export default [
    // 微能力教师成果认定
    {
        path: '/abilityachievementaffirm',
        name: 'AchievementConfirm',
        meta: {
            breadCrumd: [{
                path: '/',
                name: '信息技术应用能力认定'
            },
            {
                path: '/',
                name: '成果认定'
            },
            ]
        },
        component: () => import('../../views/personal/tearch/ability/AbilityAchievementAffirm.vue'),
    },
    // 微能力教师成果上传
    {
        path: '/abilityupLoad',
        name: 'AchievementConfirm',
        meta: {
            breadCrumd: [{
                path: '/',
                name: '信息技术应用能力认定'
            },
            {
                path: '/',
                name: '成果认定'
            },
            {
                path: '/',
                name: '上传成果'
            },
            ]
        },
        component: () => import('../../views/personal/tearch/ability/AbilityUpLoad.vue'),
    },
    // 微能力教师证书
    {
        path: '/abilitycertificate',
        name: 'AbilityCertificate',
        meta: {
            breadCrumd: [{
                path: '/',
                name: '信息技术应用能力认定'
            },
            {
                path: '/',
                name: '证书'
            }
            ]
        },
        component: () => import('../../views/personal/tearch/ability/AbilityCertificate.vue'),
    },
    // 微能力教师问卷调研
    {
        path: "/abilityquestionnaireinpuiry",
        name: "AbilityQuestionnaireInpuiry",
        meta: {
            breadCrumd: [{
                path: '/',
                name: '问卷调研'
            }]
        },
        component: () =>
            import(

                "../../views/personal/tearch/ability/AbilityQuestionnaireInpuiry.vue"
            ),
    },
    
]

export const abilityOtherRoutes = [
    // 微能力教师成果认定详情  
    {
        path: '/abilityconfirmdetail',
        name: 'AbilityConfirmDetail',
        meta: {
            breadCrumd: [{
                path: '/',
                name: '信息技术应用能力认定'
            },
            {
                path: '/',
                name: '成果认定'
            },
            {
                path: '/',
                name: '成果详情'
            }
            ]
        },
        component: () => import('../../views/personal/tearch/ability/AbilityConfirmDetail.vue'),
    },
]